var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout--prescriber",staticStyle:{"padding-top":"60px"}},[_c('NavBar'),_c('transition',{attrs:{"name":_vm.routerTransition,"mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }